import sd from '../../assets/lottiefiles/software_developer.json'
import cw from '../../assets/lottiefiles/content_writer.json'
import gd from '../../assets/lottiefiles/graphic_designer.json'
import tr from '../../assets/lottiefiles/trainer.json'


export const EDUCATION = [
    { label: 'BCA' },
    { label: 'MCA' },
    { label: 'BSc.CS|IT' },
    { label: 'MSc.CS|IT' },
    { label: 'BE.CS|IT|ECE' },
    { label: 'ME.CS|IT|ECE' },
    { label: 'BTech.CS|IT|ECE' },
    { label: 'MTech.CS|IT|ECE' },
    { label: 'PhD.CS|IT|ECE' },
]

export const WORK_EXPERIENCE = [
    { label: 'Fresher' },
    { label: '0 - 1 Year' },
    { label: '1 - 2 Year' },
    { label: '2+ Years' },
]
export const DATA = [
    {
        Title: 'Software Developer',
        BasicDescription: "Innovate and code with impact as a passionate Software Developer, shaping the future of innovative and cutting-edge applications. Be a key player in our collaborative, tech-driven team, bringing software solutions to life and actively embracing challenges as opportunities.",
        Description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        Icon: sd,
        BG: '/assets/images/careers/software_developer.jpg',
        Vaccants: 0,
        Skills: [
            'Proficiency in Python Programming',
            'Experienced with Python frameworks',
            'Strong debugging, problem-solving skills',
            'Quick technology adaptability',
            'Designs scalable software solutions',
            'Effective communicator and collaborator',
        ],
        bgcolor: '#abcdfe'
    },
    {
        Title: 'Tech-Driven Content Writer',    
        BasicDescription: "Craft engaging narratives that transcend the boundaries of academia. Join us as a creative and insightful Content Writer for Research Articles, where your words eloquently breathe life into groundbreaking, globally impactful discoveries and inspire, educate, and captivate the minds of the scholarly community.",
        Description: "Are you a talented wordsmith with a deep understanding of technical concepts? At Genesys Academy, we're in search of skilled Content Writers to join our team. We value candidates who possess an advanced degree (M.E/M.Sc/M.C.A) in domains related to computer science and have a passion for effective communication.",
        Icon: cw,
        BG: '/assets/images/careers/content_writer.jpg',
        Vaccants: 2,
        Skills: [
            'Technical Knowledge',
            'Vocabulary Excellence',
            'Fast Learner',
            'Article/Thesis Writing Support',
            'Experienced candidates are highly valued in this role.',
        ],
        bgcolor: '#fee8c0'
    },
    {
        Title: 'Scientific Illustrator',
        BasicDescription: "Looking for a skilled Graphic Designer to join our office and contribute to creating compelling visual content. The ideal candidate will have proficiency in Adobe Creative Suite, a strong understanding of design principles, and the ability to deliver high-quality work within project timelines.",
        Description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        Icon: gd,
        BG: '/assets/images/careers/designer.jpg',
        Vaccants: 2,
        Skills: [
            'Proficiency in Adobe Creative Suite (Photoshop, Illustrator, InDesign)',
            'Strong understanding of typography, color theory, and layout design',
            'Creative thinking, novelty, and innovative approach',
            'Time management and organizational skills'
        ],
        bgcolor: '#fee8c0'
    },
    {
        Title: 'Trainer',
        BasicDescription: "Inspire minds and nurture talent as a passionate Software Trainer, sharing expertise in our dynamic and transformative learning environment. Play a pivotal role in shaping the next generation of innovative tech professionals through engaging, hands-on training programs.",
        Description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        Icon: tr,
        BG: '/assets/images/careers/trainer.jpg',
        Vaccants: 0,
        Skills: [
            'Skilled in programming languages',
            'Proficient in SDLC concepts',
            'Excellent presentation and communication skills',
            'Experienced in practical training',
            'Passionate about student mentorship',
            'Tech-savvy and industry-aware',
        ],
        bgcolor: '#abcdfe'
    },
]